import { useDeleteLine } from "./api/deleteLine";
import { Button } from "reactstrap";


const DeleteLine = ({handleCloseModal, lineId}: DeleteLineProps)  => {
  
  const deleteLineMutation = useDeleteLine({ lineId});
  const handleSubmit = async (): Promise<void> => {
    deleteLineMutation.mutateAsync({ 
      lineId: lineId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε την Γραμμής;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteLineProps{
  lineId: number;
  handleCloseModal: () => void;
}

export default DeleteLine;